import React, { Component } from 'react';

import RouterManager from '@common/components/routerManager/routerManager.component';

import { connect } from '@common/components/base.component';

import navbarActions from '@common/store/navbar/navbar.actions';
import navbarSelectors from '@common/store/navbar/navbar.selectors';

class NavBarMenuAction extends Component {
  constructor(props) {
    super(props);
  }

  onClick(manager) {
    return (e) => {
      manager.redirect({ url: this.props.link.substring(1) });
    };
  }

  render() {
    const { type, link } = this.props;
    const tooltip = type == 'list' ? 'Buscar' : 'Novo';
    const $class = type == 'list' ? 'fa fa-table' : 'fa fa-plus';

    return (
      <RouterManager>
        {(manager) => (
          <a
            onClick={this.onClick(manager).bind(this)}
            style={{ color: '#ececec' }}
            className="nav-header-submenu-item-link-actions float-right text-right"
          >
            <i className={`${$class} ml-2`} />
          </a>
        )}
      </RouterManager>
    );
  }
}

export default connect({
  selectors: {
    navbarSelectors,
  },
  actions: {
    navbarActions,
  },
})(NavBarMenuAction);
